/* global $:false */

export default class ConnectionStateMonitor {
  static init () {
    if (this.monitor) { return }

    this.monitor = new ConnectionStateMonitor()
  }

  static onChange (states) {
    if (!this.monitor) { return }

    if (['connecting', 'disconnected', 'unavailable'].includes(states.current)) {
      if (states.previous === 'initialized' && states.current === 'connecting') { return }
      this.monitor.onDisconnected()
    } else if (states.current === 'connected') {
      this.monitor.onConnected()
    }
  }

  onConnected () {
    this.banner().hide()
  }

  onDisconnected () {
    this.banner().show()
  }

  banner () {
    return $('.js-connection-state-monitor')
  }
}
